import { Grid2 } from "@mui/material";

import { GqlFieldworkerAvailability } from "~/__generated__";

import AvailabilityItem from "./AvailabilityItem";

type Props = {
    availabilityData: GqlFieldworkerAvailability[];
};

export default function AvailabilitySection({ availabilityData }: Props) {
    return (
        <Grid2 size={1}>
            {availabilityData.map(availability => (
                <AvailabilityItem availability={availability} key={availability.id} />
            ))}
        </Grid2>
    );
}
